import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// Plugins patch the one shared dayjs instance (and their types widen Dayjs everywhere), so they
// are registered once here, before any other module runs: src/index.tsx and src/test/setup.ts
// import this file first. Never extend dayjs inside a feature module — what then works depends
// on which lazy route happened to load it.
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone); // needs utc
